/**
 * Query keys de banking — banca: cuentas, movimientos y PSD2.
 *
 * Se componen en `src/lib/qk.ts`, que sigue siendo el único punto de import de
 * toda la app (`@/lib/qk`). Aquí solo vive la definición; añadir una clave nueva
 * de este dominio se hace en este fichero y aparece sola en `qk`.
 *
 * Las convenciones (entidad en singular primero, `companyId` después, subsegmentos
 * en medio) están explicadas en `src/lib/qk.ts` y siguen aplicando.
 */
export const bankingKeys = {
  bankAccount: {
    all: () => ['bank-accounts'] as const,
    list: (companyId?: string, filters: Record<string, unknown> = {}) =>
      ['bank-accounts', companyId, filters] as const,
    paginated: (
      companyId?: string,
      page = 0,
      pageSize = 10,
      filters: Record<string, unknown> = {},
    ) => ['bank-accounts', 'paginated', companyId, page, pageSize, filters] as const,
    byId: (id?: string) => ['bank-accounts', id] as const,
  },

  bankMovement: {
    all: () => ['bank-movements'] as const,
    list: (companyId?: string, filters: Record<string, unknown> = {}) =>
      ['bank-movements', companyId, filters] as const,
    // #2774 — lleva `companyId`: sin él, dos empresas con el mismo `invoiceId`
    // en caché (o un cambio de empresa sin purga) comparten la entrada. Mismo
    // orden que `['accounting-entries', 'by-invoice', companyId, invoiceId]`.
    byInvoice: (companyId?: string, invoiceId?: string) =>
      ['bank-movements', 'by-invoice', companyId, invoiceId] as const,
  },

  // PSD2 Powens — connected accounts (with connection state + consent expiry).
  psd2: {
    accounts: (companyId?: string) => ['psd2-accounts', companyId] as const,
  },
} as const;
